import { getLocalizedString } from '@grandvisionhq/utils';

const mapBundleChildLineItems = (lineItem, intl)=>{
    return lineItem.bundleLineItems.filter((child)=>!child.isMainBundleLineItem
    ).map((child)=>toBundleChildLineItem(intl)(child)
    );
};
const toBundleChildLineItem = (intl)=>{
    return (child)=>{
        var ref, ref1;
        return {
            title: intl.getLabel(`cart.lineItem.glasses.bundleItem.${child.legacyProduct.productType}`),
            body: getLocalizedString(child.legacyProduct.masterData.current.name, intl.locale),
            originalPrice: (ref = child.price) === null || ref === void 0 ? void 0 : ref.total.subtotal,
            price: ((ref1 = child.price) === null || ref1 === void 0 ? void 0 : ref1.total.gross) || 0
        };
    };
};

export { mapBundleChildLineItems, toBundleChildLineItem };
//# sourceMappingURL=map-bundle-child-line-items.js.map
